// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_o4-0";